import type { Dir, LocaleCode, LocaleMeta } from './types';

export const SUPPORTED_LOCALES: readonly LocaleCode[] = ['en', 'ar', 'fr'] as const;
export const DEFAULT_LOCALE: LocaleCode = 'en';

export const LOCALE_META: Readonly<Record<LocaleCode, LocaleMeta>> = {
  en: { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr' },
  ar: { code: 'ar', name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
  fr: { code: 'fr', name: 'French', nativeName: 'Français', dir: 'ltr' },
};

export function isLocaleCode(value: unknown): value is LocaleCode {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function dirOf(code: LocaleCode): Dir {
  return LOCALE_META[code].dir;
}

export function isRTL(code: LocaleCode): boolean {
  return dirOf(code) === 'rtl';
}

export function resolveLocale(input: string | null | undefined): LocaleCode {
  if (!input) return DEFAULT_LOCALE;
  const base = input.toLowerCase().split(/[-_]/)[0];
  return isLocaleCode(base) ? base : DEFAULT_LOCALE;
}
